var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage whack-a-mole"
  }, [_vm.getWordFromRounds ? _c('div', {
    staticClass: "word"
  }, _vm._l([_vm.getWordFromRounds], function (word) {
    return _c('blinking-cursor-text', {
      key: word.answer,
      attrs: {
        "round-id": _vm.currentRound.roundIndex,
        "text-step": word.stepIndex,
        "text": word.answer
      }
    });
  }), 1) : _vm._e(), _vm.getSentenceFromRounds ? _c('div', {
    staticClass: "sentence"
  }, _vm._l([_vm.getSentenceFromRounds], function (sentence) {
    return _c('blinking-cursor-text', {
      key: sentence.answer,
      attrs: {
        "round-id": _vm.currentRound.roundIndex,
        "text-step": sentence.stepIndex,
        "text": sentence.answer ? sentence.answer : ''
      }
    });
  }), 1) : _vm._e(), _c('div', {
    staticClass: "moles-stage"
  }, [_c('figure', [_c('img', {
    staticClass: "sky-image",
    attrs: {
      "src": _vm.sky
    }
  })]), _c('text-display-list', {
    staticClass: "syllables-wrapper",
    attrs: {
      "text-size": 'large'
    }
  }, _vm._l(_vm.stepsSyllables, function (stepSyll) {
    return _c('li', {
      key: stepSyll.stepIndex,
      staticClass: "syllable-container",
      class: ("syllable-" + (stepSyll.order) + " syllable-container-" + (_vm.getNestsNumber))
    }, [_c('div', {
      class: ("dynamic-mole dynamic-mole-" + (stepSyll.stepIndex))
    }, [_c('div', {
      staticClass: "syllable-banner"
    }, _vm._l([stepSyll], function (item) {
      return _c('blinking-cursor-text', {
        key: item.answer,
        staticClass: "type-line",
        attrs: {
          "round-id": _vm.currentRound.roundIndex,
          "text-step": item.stepIndex,
          "text": item.answer
        }
      });
    }), 1), _c('img', {
      staticClass: "mole-image",
      attrs: {
        "src": stepSyll.stepIndex % 2 == 0 ? _vm.leftMole : _vm.rightMole
      }
    })]), stepSyll.stepIndex < _vm.getNestsNumber ? _c('figure', [_c('img', {
      staticClass: "nest-image",
      attrs: {
        "src": _vm.nest
      }
    })]) : _vm._e()]);
  }), 0), _c('figure', [_c('img', {
    staticClass: "grass-image",
    attrs: {
      "src": _vm.grass
    }
  })]), _c('div', {
    staticClass: "green-land"
  })], 1), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }